import { useRef } from 'react';
import '@/assets/styles/components/meet-provider-test.scss';
import MeetProviderTestIframe from './meet-provider-test-iframe';

type MeetProviderTestRef = {
	onStartTest: () => void;
};

const MeetProviderTest = () => {
	const meetWvRef = useRef<MeetProviderTestRef | null>(null);

	return (
		<div className="meet-provider-container">
			<MeetProviderTestIframe
				ref={meetWvRef}
				src={process.env.DOPI_TECH_COMPONENTS_URL + '/#/provider-tests'}
			/>
		</div>
	);
};

export default MeetProviderTest;
